<template>
  <div class="specialcar-images">
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
      height="240"
    >
      <v-carousel-item
        v-for="(image, index) in images"
        :key="index"
        :src="image"
        contain
      >
      </v-carousel-item>
    </v-carousel>
    <v-row no-gutters>
      <v-col
        v-for="(image, index) in images"
        :key="index"
        cols="2"
      >
        <v-img
          :src="image"
          :aspect-ratio="4/3"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
.specialcar-images {
  .v-carousel {
    background-color: white;
    margin-bottom: 1rem;
  }
}
</style>

<script>
export default {
  name: 'CarImages',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>
